import type {PageRouteConfig} from '@router';

import UserRegister from 'modules/UserRegister/UserRegister';

export function createUserRegisterRoute(): PageRouteConfig {
  return {
    element: <UserRegister />,
    layout: {
      title: '',
      hasNavigate: false,
      hasHeader: false,
      hasBack: false,
      hasLeftIcon: false
    },
    isProtected: false
  };
}
